import { useMemo, useState, useEffect } from 'react'
import { Budget, BudgetModuleProvider } from '#modules/Budget'
import {
	BudgetType,
	ModuleDefinition,
} from './types/authenticateSmartcheckSessionDto'
import { Region } from '@monthio/react-components'
import { budgetMock } from './Modules/Budget/storyUtils/mockBudget'
import getQueryStringParams from './getQueryStringParameters'

export const DevRoutes = () => {
	const [currentRoute, setCurrentRoute] = useState<string | null>(() => {
		const params = getQueryStringParams(window.location.search)
		return params.route || null
	})

	useEffect(() => {
		const params = new URLSearchParams(window.location.search)
		if (currentRoute) {
			params.set('devroutes', 'true')
			params.set('route', currentRoute)
		} else {
			params.delete('route')
		}
		const newUrl = `${window.location.pathname}?${params.toString()}`
		window.history.replaceState({}, '', newUrl)
	}, [currentRoute])

	const mockProps = useMemo(() => {
		return {
			startCall: () => Promise.resolve(budgetMock),
			finishCall: () =>
				new Promise<void>((resolve) => {
					setTimeout(() => {
						setCurrentRoute(null)
						resolve()
					}, 2000)
				}),
			config: {
				budgetType: BudgetType.V2,
				shouldUseBudgetHelper: false,
				shouldShowConsumerNote: true,
				shouldAllowFileUpload: true,
				shouldHideDiscretionaryIncome: false,
				partOfMultiFlow: false,
				regionId: Region.Denmark,
				clientName: 'Mock Client',
			},
		}
	}, [])

	if (!currentRoute) {
		return (
			<div style={{ padding: 20 }}>
				<h2>Dev Routes</h2>
				<p>Select a route to work on:</p>
				<ul>
					<li>
						<button onClick={() => setCurrentRoute('placeholder')}>
							Placeholder Page
						</button>
					</li>
					<li>
						<button onClick={() => setCurrentRoute('budget')}>
							Budget Module
						</button>
					</li>
				</ul>
			</div>
		)
	}

	if (currentRoute === 'budget') {
		return (
			<BudgetModuleProvider
				moduleType={ModuleDefinition.Budget}
				startCall={mockProps.startCall}
				finishCall={mockProps.finishCall}
				config={mockProps.config}
				isDev={true}
			>
				<Budget />
			</BudgetModuleProvider>
		)
	}

	if (currentRoute === 'placeholder') {
		return (
			<div style={{ padding: 20 }}>
				<h2>Placeholder Dev Route</h2>
				<p>This is a sandbox page you can modify freely.</p>
				<button onClick={() => setCurrentRoute(null)}>
					Back to Dev Routes Menu
				</button>
			</div>
		)
	}

	return (
		<>
			<div>Unknown dev route: {currentRoute}</div>
			<button onClick={() => setCurrentRoute(null)}>Back</button>
		</>
	)
}
